import { render, staticRenderFns } from "./DecisionBox.vue?vue&type=template&id=3bb6a6c5&scoped=true&"
import script from "./DecisionBox.vue?vue&type=script&lang=js&"
export * from "./DecisionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb6a6c5",
  null
  
)

export default component.exports